import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router";
import './css/index.css';
import './css/tables.css';
import './css/maps.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/ma">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
